import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { LANDING_CONTAINER_MAX_WIDTH, landingGridSpacing, landingSectionSpacing } from '@/constants/landingLayout';
import { aiFeatures } from './condominiumProductContent';

export default function CondoAIFeaturesSection() {
  return (
    <Box sx={{ ...landingSectionSpacing, bgcolor: 'background.default' }}>
      <Container maxWidth={LANDING_CONTAINER_MAX_WIDTH}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2 }}>
            <AutoAwesome sx={{ fontSize: 40, color: '#9c27b0' }} />
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Inteligência Artificial Integrada
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto', fontSize: '1.1rem' }}>
            Diferencie-se com tecnologia de ponta. Com a possibilidade de usar sua conta da OpenAI, sua IA trabalha
            para você, identificando padrões, otimizando processos e prevenindo problemas antes que aconteçam.
          </Typography>
        </Box>
        <Grid container spacing={landingGridSpacing.cards}>
          {aiFeatures.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                elevation={3}
                sx={{
                  height: '100%',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  border: '2px solid',
                  borderColor: 'primary.light',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 8,
                    borderColor: 'primary.main',
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>{feature.icon}</Box>
                  <Typography
                    variant="h5"
                    component="h3"
                    gutterBottom
                    sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
                    {feature.description}
                  </Typography>
                  <Box component="ul" sx={{ m: 0, pl: 2 }}>
                    {feature.benefits.map((benefit, idx) => (
                      <Typography key={idx} component="li" variant="body2" sx={{ mb: 1.5, color: 'text.primary' }}>
                        <strong>✓</strong> {benefit}
                      </Typography>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
